/**
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { CommittedItem } from 'src/content/app/species-selector/types/committedItem';
import type { BriefGenomeSummary } from 'src/shared/state/genome/genomeTypes';

export const buildCommittedItemFromBriefGenomeSummary = (
  genome: Omit<BriefGenomeSummary, 'latest_genome'>
): CommittedItem => {
  return {
    genome_id: genome.genome_id,
    genome_tag: genome.genome_tag,
    common_name: genome.common_name,
    scientific_name: genome.scientific_name,
    species_taxonomy_id: genome.species_taxonomy_id,
    type: genome.type,
    is_reference: genome.is_reference,
    assembly: {
      accession_id: genome.assembly.accession_id,
      name: genome.assembly.name
    },
    release: genome.release,
    isEnabled: true,
    addedAt: Date.now()
  };
};
